((context) => {
  const record = async (trackingParams, eventType) => fetch(
    "/api/tracking_params_events",
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ tracking_params: trackingParams, event_type: eventType, referer: document.referrer })
    }
  );

  const recordView = async (trackingParams) => record(trackingParams, 'view');
  const recordClick = async (trackingParams) => record(trackingParams, 'click');

  context.TrackingParams = { recordView, recordClick };
})(window);
